<script setup>
import { ref } from "vue"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import StoreModal from "./StoreModal.vue"
import StoreEditModal from "./StoreEditModal.vue"
import SettlementModal from "./SettlementModal.vue"
import StoresTable from "./StoresTable.vue"


const title = "مدیریت فروشگاه ها"
const items = ref([
  {
    text: "داشبورد",
    href: "/",
  },
  {
    text: "مدیریت فروشگاه ها",
    active: true,
  },
])

const DEFAULT_STORE = {
  id: "",
  first_name: "",
  last_name: "",
  phone_number: "",
  email: "",
  password: "",
  password_confirmation: "",
  status: "",
}

const storeModel = ref({ ...DEFAULT_STORE })
const showStoreModal = ref(false)
const showStoreEditModal = ref(false)
const showStoreSettlementModal = ref(false)

const showAddNewModal = () => {
  showStoreModal.value = true
}

const showEditModal = () => {
  showStoreEditModal.value = true
}

const showSettlementModal = () => {
  showStoreSettlementModal.value = true
}

const editStore = (sto) => {
  storeModel.value = sto
  showEditModal()
}

const settlement = (sto) => {
  storeModel.value = sto
  showSettlementModal()
}

const onModalClose = () => {
  storeModel.value = { ...DEFAULT_STORE }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col lg="12">
        <b-card no-body id="storeList">
          <b-card-header class="border-bottom-dashed">
            <b-row class="g-4 align-items-center">
              <b-col sm>
                <div>
                  <h5 class="card-title mb-0">لیست فروشگاه ها</h5>
                </div>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                  <b-button
                    type="button"
                    variant="success"
                    class="add-btn me-1"
                    id="create-btn"
                    @click="showAddNewModal()"
                  >
                    <i class="ri-add-line align-bottom me-1"></i> افزودن فروشگاه
                    جدید
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>

          <!-- stores table  -->

          <StoresTable @clickEdit="editStore" @clickSettlement="settlement" />

          <!-- add and edit store modal  -->

          <StoreModal
            v-model="showStoreModal"
            :storeProps="storeModel"
            @close="onModalClose"
          />

          <StoreEditModal
            v-model="showStoreEditModal"
            :storeProps="storeModel"
            @close="onModalClose"
          />

          <SettlementModal
            v-model="showStoreSettlementModal"
            :storeProps="storeModel"
            @close="onModalClose"
          />
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<style>
.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem 0.5rem 2.7rem !important;
  background-position: left 0.9rem center !important;
}

.invalid-feedback {
  display: block !important;
}
</style>
